import { useUiStore } from '@/state/uiStore';

/**
 * Compact bottom-left toast stack. Each toast auto-expires after ~2s via
 * the store's pushToast helper; clicking also dismisses it. Deliberately
 * minimal styling so it doesn't compete with the 3D viewport.
 */
export function Toasts() {
  const toasts = useUiStore((s) => s.toasts);
  const dismiss = useUiStore((s) => s.dismissToast);
  if (toasts.length === 0) return null;
  return (
    <div className="toasts" role="status" aria-live="polite">
      {toasts.map((t) => (
        <button
          key={t.id}
          type="button"
          className={`toast toast--${t.tone}`}
          onClick={() => dismiss(t.id)}
          title="Dismiss"
        >
          {t.message}
        </button>
      ))}
    </div>
  );
}
